import type { DocumentStatus, DocumentType } from './api';

export const DOCUMENT_TYPES: Array<{ value: DocumentType; label: string }> = [
	{ value: 'invoice_incoming', label: 'Inkoopfactuur' },
	{ value: 'invoice_outgoing', label: 'Verkoopfactuur' },
	{ value: 'credit_note', label: 'Creditnota' },
	{ value: 'reminder', label: 'Aanmaning' },
	{ value: 'contract', label: 'Contract' },
	{ value: 'employment_contract', label: 'Arbeidsovereenkomst' },
	{ value: 'quote', label: 'Offerte' },
	{ value: 'letter_incoming', label: 'Inkomende brief' },
	{ value: 'letter_outgoing', label: 'Uitgaande brief' },
	{ value: 'government_decision', label: 'Beschikking' },
	{ value: 'insurance_claim', label: 'Zorgverzekeraar' },
	{ value: 'policy', label: 'Polis' },
	{ value: 'payslip', label: 'Loonstrook' },
	{ value: 'annual_statement', label: 'Jaaropgave' },
	{ value: 'report', label: 'Rapportage' },
	{ value: 'receipt', label: 'Bon' },
	{ value: 'other', label: 'Overig' },
];

export const DOCUMENT_STATUSES: Array<{ value: DocumentStatus; label: string }> = [
	{ value: 'received', label: 'Ontvangen' },
	{ value: 'processing', label: 'Verwerking' },
	{ value: 'classified', label: 'Geclassificeerd' },
	{ value: 'completed', label: 'Gereed' },
	{ value: 'error', label: 'Fout' },
	{ value: 'duplicate', label: 'Dubbel' },
	{ value: 'skipped', label: 'Overgeslagen' },
];

export const DIRECTIONS = [
	{ value: 'incoming', label: 'Inkomend' },
	{ value: 'outgoing', label: 'Uitgaand' },
] as const;

export const REFERENCE_TYPES = [
	{ value: 'invoice_number', label: 'Factuurnummer' },
	{ value: 'letter_ref', label: 'Briefkenmerk' },
	{ value: 'case_number', label: 'Dossiernummer' },
	{ value: 'policy_number', label: 'Polisnummer' },
	{ value: 'other', label: 'Overig' },
] as const;

import type { ExactPaymentStatus, ExactStatus } from './api';

export const EXACT_STATUS_LABELS: Record<ExactStatus, string> = {
	pending_review: 'Open',
	approved: 'Goedgekeurd',
	sent: 'Geboekt',
	failed: 'Fout',
	not_applicable: 'Afgewezen',
	already_present: 'Al geboekt',
};

export const PAYMENT_STATUS_LABELS: Record<ExactPaymentStatus, string> = {
	paid: 'Betaald',
	partial: 'Deels betaald',
	open: 'Niet betaald',
};

// Tailwind background-classes voor de status-bolletjes. Centraal gehouden zodat
// list/detail/document-pagina hetzelfde kleur-mapping delen.
export const PAYMENT_STATUS_DOT: Record<ExactPaymentStatus, string> = {
	paid: 'bg-emerald-600',
	partial: 'bg-amber-500',
	open: 'bg-red-600',
};

export const AUDIT_EVENT_LABELS: Record<string, string> = {
	mail_received: 'Mail ontvangen',
	document_received: 'Document opgeslagen',
	duplicate_detected: 'Dubbele detectie',
	ocr_started: 'OCR gestart',
	ocr_completed: 'OCR voltooid',
	classification_started: 'Classificatie gestart',
	classification_completed: 'Classificatie voltooid',
	vector_indexed: 'Geïndexeerd',
	error_occurred: 'Fout',
	retry_initiated: 'Retry gestart',
	inkoop_promoted: 'Naar inkoopfacturen verplaatst',
	exact_export_requeued: 'Opnieuw naar Exact aangeboden',
	inkoop_email_route_override: 'Inkoop-route: type geforceerd',
	manual_action: 'Handmatige actie',
};
